<!-- 医院上报及统计 -->
<template>
<div class='monitorRptIdxParent'>
  <v-header :headTitle='headTitle' v-on:getHeaderHeight='getHeaderHeight' :isBack='true' :comeFrom='$route.query.comeFrom' :pageName="pageName"></v-header>
  <div class="monitorRptIdxParent-container" :style='{"background-color":tableIndex==0?"#f2f2f2":"#fff","height":containerHeight}'>
     <v-monitorRptIndex ref="monitorRptIndex" v-if='tableIndex==0'></v-monitorRptIndex>
     <!-- <v-monitorStatistics v-else></v-monitorStatistics> -->
     <v-hospitalStatistics v-if="tableIndex==1 && batch == 2021" :containerHeight='containerHeight' :topHeight='topHeight'></v-hospitalStatistics>
     <v-hospitalStatistics2023 v-if="tableIndex==1 && (batch == 2023 || batch == 2025)" :containerHeight='containerHeight' :topHeight='topHeight'></v-hospitalStatistics2023>
  </div>
  <v-footer v-on:changeBottomTab='changeBottomTab' :pageName='pageName'></v-footer>
</div>
</template>

<script>
import footer from '../../components/footer/footer.vue'
import header from '../../components/header/header'
import monitorRptIndex from './monitorRptIndex.vue'
// import monitorStatistics from './monitorStatistics.vue'
import hospitalStatistics from './hospitalStatistics.vue'
import hospitalStatistics2023 from './hospitalStatistics2023.vue'
export default {
data() {
return {
  batch:'',
  containerHeight:0,
  topHeight:0,
  tableIndex:0,
  pageName: 'hospitalStatistics',
  headTitle:localStorage.getItem('taskName')
};
},
created() {
  this.batch = localStorage.getItem('batch')
  document.title = localStorage.getItem('taskName')
},
components: {
  'v-footer': footer,
  'v-monitorRptIndex':monitorRptIndex,
  // 'v-monitorStatistics':monitorStatistics,
  'v-hospitalStatistics':hospitalStatistics,
  'v-hospitalStatistics2023':hospitalStatistics2023,
  'v-header': header
},
beforeRouteLeave(to, from, next) {
  this.$nextTick(()=>{
    this.$refs.monitorRptIndex.handleUnfoldItemIndex()
  })
  next()
},
methods: {
  getHeaderHeight(val){
    console.log(val,'val');
    this.containerHeight = `calc(100vh - ${val+50}px)`  // 减号左右两边必须有空格
    this.topHeight = (val-1)+'px'
  },
  changeBottomTab(val){
    this.tableIndex = val
  },
  fatherMethod() {
    this.tableIndex = 1
  }

},
}
</script>
<style lang='scss' scoped>
.monitorRptIdxParent{
  display: flex;
  flex-direction: column;
  height: 100vh;
  .monitorRptIdxParent-container{
    padding-bottom: 40px;
    // height: calc(100vh - 117px); // 动态获取
    overflow: scroll;
  }
}
</style>